// This file was auto generated by resource-sync tools.

import ar_shop_set_web from './ar/shop_set_web.json';
import en_shop_set_web from './en/shop_set_web.json';
import ptBR_shop_set_web from './pt-BR/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import ar_account_web from './ar/account_web.json';
import en_account_web from './en/account_web.json';
import ptBR_account_web from './pt-BR/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';
import ar_marketing_web from './ar/marketing_web.json';
import en_marketing_web from './en/marketing_web.json';
import ptBR_marketing_web from './pt-BR/marketing_web.json';
import zh_marketing_web from './zh/marketing_web.json';
import zhHK_marketing_web from './zh-HK/marketing_web.json';
import ar_b_ad_fe from './ar/b_ad_fe.json';
import en_b_ad_fe from './en/b_ad_fe.json';
import ptBR_b_ad_fe from './pt-BR/b_ad_fe.json';
import zh_b_ad_fe from './zh/b_ad_fe.json';
import zhHK_b_ad_fe from './zh-HK/b_ad_fe.json';
import ar_pos_order_process_web from './ar/pos_order_process_web.json';
import en_pos_order_process_web from './en/pos_order_process_web.json';
import ptBR_pos_order_process_web from './pt-BR/pos_order_process_web.json';
import zh_pos_order_process_web from './zh/pos_order_process_web.json';
import zhHK_pos_order_process_web from './zh-HK/pos_order_process_web.json';
import ar_openapi from './ar/openapi.json';
import en_openapi from './en/openapi.json';
import ptBR_openapi from './pt-BR/openapi.json';
import ur_openapi from './ur/openapi.json';
import zh_openapi from './zh/openapi.json';
import zhHK_openapi from './zh-HK/openapi.json';
import ar_b_academy from './ar/b_academy.json';
import en_b_academy from './en/b_academy.json';
import ptBR_b_academy from './pt-BR/b_academy.json';
import zh_b_academy from './zh/b_academy.json';
import zhHK_b_academy from './zh-HK/b_academy.json';
import ar_multi_stores_management from './ar/multi_stores_management.json';
import en_multi_stores_management from './en/multi_stores_management.json';
import ptBR_multi_stores_management from './pt-BR/multi_stores_management.json';
import zh_multi_stores_management from './zh/multi_stores_management.json';
import zhHK_multi_stores_management from './zh-HK/multi_stores_management.json';
import ar_b_ad_web from './ar/b_ad_web.json';
import en_b_ad_web from './en/b_ad_web.json';
import zh_b_ad_web from './zh/b_ad_web.json';


const resources = {
    // 'namespaces': 
    // [{"localeInfos":[{"locale":"ar","version":456},{"locale":"en","version":524},{"locale":"pt-BR","version":263},{"locale":"zh","version":396},{"locale":"zh-HK","version":353}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"dtu0qybsds","namespaceName":"shop_set_web"}},{"localeInfos":[{"locale":"ar","version":69},{"locale":"en","version":103},{"locale":"pt-BR","version":60},{"locale":"zh","version":89},{"locale":"zh-HK","version":66}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"olipmd4ssu","namespaceName":"account_web"}},{"localeInfos":[{"locale":"ar","version":533},{"locale":"en","version":663},{"locale":"pt-BR","version":306},{"locale":"zh","version":643},{"locale":"zh-HK","version":513}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"2jvsptqql2","namespaceName":"marketing_web"}},{"localeInfos":[{"locale":"ar","version":133},{"locale":"en","version":711},{"locale":"pt-BR","version":96},{"locale":"zh","version":554},{"locale":"zh-HK","version":463}],"i18nConfig":{"apiKey":"ec21d67c5e924c3b90533d9ea791a836","projectId":19,"namespaceId":"b3ywlb2ytp","namespaceName":"b_ad_fe"}},{"localeInfos":[{"locale":"ar","version":469},{"locale":"en","version":510},{"locale":"pt-BR","version":226},{"locale":"zh","version":472},{"locale":"zh-HK","version":373}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"xop8sebnvt","namespaceName":"pos_order_process_web"}},{"localeInfos":[{"locale":"ar","version":283},{"locale":"en","version":282},{"locale":"pt-BR","version":177},{"locale":"ur","version":6},{"locale":"zh","version":340},{"locale":"zh-HK","version":225}],"i18nConfig":{"apiKey":"c8a8b802de0447359433a0aaa8e51bf8","projectId":6,"namespaceId":"9r6pgmjj1c","namespaceName":"openapi"}},{"localeInfos":[{"locale":"ar","version":20},{"locale":"en","version":21},{"locale":"pt-BR","version":19},{"locale":"zh","version":23},{"locale":"zh-HK","version":20}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"9ki0xv9rcg","namespaceName":"b_academy"}},{"localeInfos":[{"locale":"ar","version":15},{"locale":"en","version":15},{"locale":"pt-BR","version":15},{"locale":"zh","version":15},{"locale":"zh-HK","version":15}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"njycynjjri","namespaceName":"multi_stores_management"}},{"localeInfos":[{"locale":"ar","version":5},{"locale":"en","version":5},{"locale":"zh","version":5}],"i18nConfig":{"apiKey":"6df03e0ef30643309d7b32ad2f05a9a8","projectId":81,"namespaceId":"ut4hdximio","namespaceName":"b_ad_web"}}],
    'ar': {
        shop_set_web: ar_shop_set_web,
        account_web: ar_account_web,
        marketing_web: ar_marketing_web,
        b_ad_fe: ar_b_ad_fe,
        pos_order_process_web: ar_pos_order_process_web,
        openapi: ar_openapi,
        b_academy: ar_b_academy,
        multi_stores_management: ar_multi_stores_management,
        b_ad_web: ar_b_ad_web
    },
    'en': {
        shop_set_web: en_shop_set_web,
        account_web: en_account_web,
        marketing_web: en_marketing_web,
        b_ad_fe: en_b_ad_fe,
        pos_order_process_web: en_pos_order_process_web,
        openapi: en_openapi,
        b_academy: en_b_academy,
        multi_stores_management: en_multi_stores_management,
        b_ad_web: en_b_ad_web
    },
    'pt-BR': {
        shop_set_web: ptBR_shop_set_web,
        account_web: ptBR_account_web,
        marketing_web: ptBR_marketing_web,
        b_ad_fe: ptBR_b_ad_fe,
        pos_order_process_web: ptBR_pos_order_process_web,
        openapi: ptBR_openapi,
        b_academy: ptBR_b_academy,
        multi_stores_management: ptBR_multi_stores_management
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        account_web: zh_account_web,
        marketing_web: zh_marketing_web,
        b_ad_fe: zh_b_ad_fe,
        pos_order_process_web: zh_pos_order_process_web,
        openapi: zh_openapi,
        b_academy: zh_b_academy,
        multi_stores_management: zh_multi_stores_management,
        b_ad_web: zh_b_ad_web
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        account_web: zhHK_account_web,
        marketing_web: zhHK_marketing_web,
        b_ad_fe: zhHK_b_ad_fe,
        pos_order_process_web: zhHK_pos_order_process_web,
        openapi: zhHK_openapi,
        b_academy: zhHK_b_academy,
        multi_stores_management: zhHK_multi_stores_management
    },
    'ur': {
        openapi: ur_openapi
    }
};

export default resources;